import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { __ } from "../../utils";
import { useStores } from "../../store";
const NoticeBannerActiveNoCookies = observer(()=>{
    const { optionStore: { publicCookieCount, busySettings, isBannerActive } } = useStores();
    return isBannerActive && !publicCookieCount && !busySettings && /*#__PURE__*/ _jsx("div", {
        className: "notice notice-warning inline below-h2 notice-alt",
        style: {
            margin: "10px 0 0 0"
        },
        children: /*#__PURE__*/ _jsx("p", {
            children: __("The cookie banner is activated, but unfortunately you have not yet created or enabled services.")
        })
    });
});
export { NoticeBannerActiveNoCookies };
